'use client'

import { Spacer } from '@vinted/web-ui'
import { FormProvider, useForm } from 'react-hook-form'

import { createProIntegrationsApplication } from '@marketplace-web/pro-integrations/pro-integrations-data'

import ApiError from '../ApiError'
import ApiImplementation from '../ApiImplementation'
import BusinessDetails from '../BusinessDetails'
import Footer from '../Footer'
import FormSuccess from '../FormSuccess'
import Header from '../Header'
import TermsAndConditions from '../TermsAndConditions'
import { ProIntegrationsApplicationFormField } from '../constants'
import { ProIntegrationsApplicationFormModel } from '../types'

const Form = () => {
  const methods = useForm<ProIntegrationsApplicationFormModel>()
  const { handleSubmit, formState, setError } = methods

  const onSubmit = async (fieldValues: ProIntegrationsApplicationFormModel) => {
    const requestBody = {
      shop_url: fieldValues.shop_url,
      item_types: fieldValues.item_types,
      item_amount: fieldValues.item_amount,
      item_value: fieldValues.item_value,
      monthly_listings: fieldValues.monthly_listings,
      api_implementation: fieldValues.api_implementation,
      third_party: fieldValues.third_party,
    }

    const response = await createProIntegrationsApplication(requestBody)

    if ('errors' in response) {
      setError(ProIntegrationsApplicationFormField.ApiError, { type: 'manual' })
    }
  }

  if (formState.isSubmitSuccessful) {
    return <FormSuccess />
  }

  return (
    <FormProvider {...methods}>
      <ApiError />
      <Header />
      <form onSubmit={handleSubmit(onSubmit)}>
        <BusinessDetails />
        <Spacer size={Spacer.Size.X2Large} />
        <ApiImplementation />
        <Spacer size={Spacer.Size.X2Large} />
        <TermsAndConditions />
        <Spacer size={Spacer.Size.X2Large} />
        <Footer />
        <Spacer size={Spacer.Size.X5Large} />
      </form>
    </FormProvider>
  )
}

export default Form
